export default __webpack_public_path__ + "static/media/logo-km-simple.be45a2ca.svg";